import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { ComponentRegistration } from '../../../core';
import { Dto } from '../../../data';
import { ICustomerSettingsService } from '../../../services';
import {IParkHouse, IPromotionSettings} from "../../../data/interfaces";
let template = require('./fpp-settings.html');

const ALL_PARK_HOUSES: IParkHouse = {
    id: 1,
    name: 'All Parkhouses',
    isEveryone: true,
    externalId: "1",
    enabled: true,
    parkHouseId: -1
}

class FppSettingsComponent extends ComponentRegistration {

    constructor() {
        super('fppSettings', {
            controller: FppSettingsController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
            }
        });
    }
}

interface IFppSettingsController {

}

class FppSettingsController implements IFppSettingsController {
    private static $inject: Array<string> = ['$mdpTimePicker', '$timeout', '$q', '$mdDialog', '$rootRouter', 'CustomerSettings'];
    public ScheduleTypes = Dto.ScheduleTypeEnum;
    public DayOfWeek = Dto.DayOfWeek;
    private setupForm: ng.IFormController;
    private promotions: Array<Dto.IPromotionSettings>;
    private groups: Array<Dto.IPromotionGroup>;
    private parkHouses: Array<Dto.IParkHouse>;
    private _selectedPromotion: Dto.IPromotionSettings;
    private _recentlyClickedParkHouse: Dto.IParkHouse;
    private orignalSettings: Dto.ISettings<Dto.IFrequentParkerSettings>;
    private loseChangesMessage = "Changes will be lost. Are you sure?";
    private urlId: string;

    constructor(private $mdpTimePicker: any,
        private $timeout: ng.ITimeoutService,
        private $q: ng.IQService,
        private $mdDialog: ng.material.IDialogService,
        private $router: ng.Router,
        private CustomerSettings: ICustomerSettingsService) {
        console.log('SetUpFormController loading');

    }

    public $onInit(): void {
        this.promotions = [];
        this.CustomerSettings.getFrequentParkerSettings(true)
            .then((response) => {
                this.orignalSettings = ng.copy(response);
                this.promotions = response.settings.promotionSettings;
                initializeParkHouses(this.promotions);
                
                this.groups = Linq.From(response.settings.groups)
                    .Where(x => x.enabled).ToArray();
                
                this.parkHouses = Linq.From([ALL_PARK_HOUSES, ...response.settings.parkHouses]).ToArray();

                if (this.urlId) {
                    this.$timeout(() => {
                        this.selectedPromotion = Linq.From(this.promotions).FirstOrDefault(x => x.id === this.urlId);
                    });                   
                }
            });
    }

    public $routerOnActivate(next, previous) {
        // Get the account identified by the route parameter
        this.urlId = next.params.id;
    }

    public navigate(address: Array<string>): void {
        this.$router.navigate(address);
    }

    public get selectedPromotion() {
        return this._selectedPromotion;
    }

    public set selectedPromotion(val: Dto.IPromotionSettings) {
        if (this._selectedPromotion !== val) {
            if (val != null && this._selectedPromotion != null
                && this._selectedPromotion.id !== val.id
                && !(this._selectedPromotion.isNew || val.isNew)
                && (this._selectedPromotion.isNew || this.setupForm.$dirty)) {
                this.showLoseChangesWarning().then(() => {
                    var previous = this._selectedPromotion;
                    this.changeSelection(val);
                    if (previous) {

                        if (!previous.isNew) {
                            this.revertExistingItem(previous.id);
                            this.setFormPristine();
                        } else {
                            this.promotions.remove(previous);
                        }
                    }
                },
                    () => {
                        if (val && val.isNew) {
                            this.promotions.remove(val);
                        }
                    });
            }
            else {
                this.changeSelection(val);
            }
        }
    }

    private changeSelection(val: Dto.IPromotionSettings) {
        this._selectedPromotion = val;

        if (this._selectedPromotion) {
            this.normalizeSchedule(this._selectedPromotion.schedule);
            this.setFormPristine();
        }
        
    }

    public handleParkHouseSelectionChanged() {
        if (!this._recentlyClickedParkHouse)
            return;

        // user selects All Parkhouses, deselect everything else
        // user has All Parkhouses selected then selects something else, deselect All Parkhouses
        this._selectedPromotion.parkHouses = this._selectedPromotion.parkHouses.filter(ph=>ph.isEveryone == this._recentlyClickedParkHouse.isEveryone);
    }
    
    public handleParkHouseClick(parkHouse: IParkHouse){
        this._recentlyClickedParkHouse = parkHouse;
    }
    
    public showEditButtons() {
        return this.selectedPromotion
            && (this.setupForm.$dirty || this.selectedPromotion.isNew);
    }

    public isNamedDaysGroupSelected() {
        return (!this.selectedPromotion
            || !this.selectedPromotion.schedule
            || this.selectedPromotion.schedule.scheduleType === Dto.ScheduleTypeEnum.All
            || this.selectedPromotion.schedule.scheduleType === Dto.ScheduleTypeEnum.Weekdays
            || this.selectedPromotion.schedule.scheduleType === Dto.ScheduleTypeEnum.Weekends
        );
    }

    public isCustomDaysGroupSelected() {
        return (this.selectedPromotion
            && this.selectedPromotion.schedule
            && this.selectedPromotion.schedule.scheduleType === Dto.ScheduleTypeEnum.Custom);
    }

    public IsDefaultOrNotSelected() {
        return !this.selectedPromotion || this.selectedPromotion.isDefault;
    }

    public normalizeSchedule(schedule: Dto.ISchedule): void {

        if (schedule && schedule.scheduleType == Dto.ScheduleTypeEnum.Custom) {
            let promoCustomDays = Linq.From(schedule.activeTimes)
                .Select(x => x.dayOfWeek);

            let missingDays = Linq.From(Object.keys(this.DayOfWeek))
                .Where(x => isNaN(x as any))
                .Where(x => !promoCustomDays.Contains(Dto.DayOfWeek[x]))
                .Select(x => {
                    return {
                        enabled: false,
                        dayOfWeek: Dto.DayOfWeek[x],
                    } as Dto.ICustomActiveTime;
                }).ToArray() || [];

            let customDays = missingDays.concat(schedule.activeTimes || []);

            schedule.activeTimes = Linq.From(customDays)
                .OrderBy(x => x.dayOfWeek).ToArray();
        }
        else {
            schedule.activeTimes = [];
        }
    }

    private deleteSelectedPromo(): void {

        if (this.selectedPromotion && !this.selectedPromotion.isDefault) {
            var tempPromo = this.selectedPromotion;

            this.promotions.remove(tempPromo);
            this.selectedPromotion = undefined;
            if (!tempPromo.isNew) {
                this.save("Delete Successful.");
            }

            var lastNewPromo = Linq.From(this.promotions).FirstOrDefault(x => x.isNew);
            this.selectedPromotion = lastNewPromo;
        }
    }

    public onDelete(): void {
        if (this.selectedPromotion && !this.selectedPromotion.isDefault) {

            this.showLoseChangesWarning("Are you sure you want to delete this Promotion?").then(() => {
                this.deleteSelectedPromo();
            });
        }
    }

    public createNew(): void {
        let tmpPromo = {
            id: Object.newGuid(),
            isNew: true,
            isDefault: false,
            name: this.getUniquePromoName(),
            groups: [],
            isActive: true,
            schedule: {
                allDay: true,
                scheduleType: Dto.ScheduleTypeEnum.All,

            },
        } as Dto.IPromotionSettings;

        var defaultPromo = Linq.From(this.promotions).FirstOrDefault(x => x.isDefault);
        var insertPos = this.promotions.indexOf(defaultPromo);
        this.promotions.insert(tmpPromo, insertPos);
        this.selectedPromotion = tmpPromo;
        this.setFormPristine();
    }

    private getUniquePromoName() {
        let incremntor = 0;
        let newName = "";

        do {
            incremntor++;
            newName = `New Promo ${incremntor}`;
        } while (Linq.From(this.promotions).Any(x => x.name === newName));

        return newName
    }

    public onAdd() {
        if (this._selectedPromotion != null
            && (this._selectedPromotion.isNew)) {
            this.showLoseChangesWarning().then(() => {
                var val = this._selectedPromotion;
                this.createNew();
                if (val && val.isNew) {
                    this.promotions.remove(val);
                }

            });
        }
        else {
            this.createNew();
        }
    }

    private setFormPristine() {
        this.setupForm.$setPristine();
        this.setupForm.$setUntouched();
    }

    public onGroupsClose() {
        if (this.selectedPromotion.groups.length > 1) {
            this.selectedPromotion.groups.remove(x => x.isEveryone);
        }
    }

    public onCancel(): void {
        if (this.selectedPromotion) {
            this.showLoseChangesWarning().then(() => {
                if (!this.selectedPromotion.isNew) {

                    let origPromo = this.revertExistingItem(this.selectedPromotion.id);
                    this.selectedPromotion = origPromo;
                }
                else {
                    this.deleteSelectedPromo();
                }
            });
        }
    }

    private revertExistingItem(id: String): Dto.IPromotionSettings {

        let origPromo = Linq.From(this.orignalSettings.settings.promotionSettings)
            .FirstOrDefault(x => x.id === id);

        var modified = Linq.From(this.promotions)
            .FirstOrDefault(x => x.id === id);

        let index = this.promotions.indexOf(modified);

        if (index >= 0) {
            this.promotions[index] = origPromo;
        }
        return origPromo;
    }

    public onCustomScheduleSelected() {
        if (this.selectedPromotion
            && this.selectedPromotion.schedule
            && this.selectedPromotion.schedule.scheduleType == Dto.ScheduleTypeEnum.Custom) {
            this.normalizeSchedule(this.selectedPromotion.schedule);
        }
    }

    private showLoseChangesWarning(message?: string): ng.IPromise<any> {

        var confirm = this.$mdDialog.confirm()
            .title('Warning')
            .textContent(message || this.loseChangesMessage)
            .ok('Yes')
            .cancel('No');

        return this.$mdDialog.show(confirm);
    }

    public onSave(): void {
        this.save();
    }
    public save(message?: string): void {
        const fppSettings = ng.copy(this.orignalSettings);
        this.promotions.forEach(ps => ps.parkHouses = !!ps.parkHouses ? ps.parkHouses.filter(x=>!x.isEveryone): []);
        fppSettings.settings.promotionSettings = this.promotions;
        
        this.CustomerSettings.saveFrequentParkerSettings(fppSettings, message)
            .then((response) => {
                this.orignalSettings = ng.copy(response);
                this.promotions = response.settings.promotionSettings;

                initializeParkHouses(this.promotions);
                
                this.groups = Linq.From(response.settings.groups)
                    .Where(x => x.enabled).ToArray();
                
                this.parkHouses = Linq.From([ALL_PARK_HOUSES, ...response.settings.parkHouses]).ToArray();
                
                if (this.selectedPromotion) {
                    this.selectedPromotion = Linq.From(this.promotions)
                        .FirstOrDefault(x => x.id == this.selectedPromotion.id);
                }

                this.$timeout(() => {
                    //must run next after this digest cycle completes.
                    this.setFormPristine();
                });

            }).catch((e) => {
                
            });
    }
    
}

const initializeParkHouses = (promotionSettings: IPromotionSettings[]) => {
    promotionSettings.forEach(ps => {
        ps.parkHouses = ps.parkHouses || [];
        if (ps.parkHouses.length == 0)
            ps.parkHouses.push(ALL_PARK_HOUSES);
    });
}

let component = new FppSettingsComponent();
export default component;
export { component as FppSettingsComponent, IFppSettingsController, FppSettingsController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/setup/fpp-settings.ts